import { NavBar } from "@/components/NavBar";
import { LoginForm } from "@/components/auth/LoginForm";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <div className="flex-1 flex-col flex items-center justify-center p-4 bg-muted/50">
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
